module.exports = __webpack_public_path__ + "img/bg_1920x1080.50a6c684.jpeg";